import {
  collection,
  addDoc,
  getDocs,
  getDoc,
  doc,
  deleteDoc,
  query,
  where,
  serverTimestamp,
  Timestamp
} from 'firebase/firestore';
import { db } from '../../firebase';
import { auditService, AUDIT_MODULES, AUDIT_ACTIONS, AUDIT_TAGS } from '../system/audit';

const COLLECTION_NAME = 'internalDriverPayments';

export const internalDriverPaymentsService = {
  async getPaymentsForDriver(companyId, driverId) {
    const q = query(
      collection(db, COLLECTION_NAME),
      where('companyId', '==', companyId),
      where('driverId', '==', driverId)
    );
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  },

  async getAllPayments(companyId) {
    const q = query(
      collection(db, COLLECTION_NAME),
      where('companyId', '==', companyId)
    );
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  },

  async addPayment({ companyId, driverId, amount, paymentDate, method, notes, createdBy }) {
    const dateValue = paymentDate ? new Date(paymentDate) : new Date();
    const data = {
      companyId,
      driverId,
      amount: Number(amount) || 0,
      paymentDate: Timestamp.fromDate(dateValue),
      method: method || 'cash',
      notes: notes || '',
      createdBy: createdBy || null,
      createdAt: serverTimestamp()
    };
    const ref = await addDoc(collection(db, COLLECTION_NAME), data);
    auditService.log({
      module: AUDIT_MODULES.PAYMENT,
      action: AUDIT_ACTIONS.PAYMENT_RECORDED,
      recordId: ref.id,
      recordLabel: `Driver payment ${Number(amount) || 0} → ${driverId}`,
      after: data,
      tags: [AUDIT_TAGS.ALL, AUDIT_TAGS.FINANCIAL, AUDIT_TAGS.DRIVER_CHANGES],
      companyId,
      meta: { driverId, paymentNumber: ref.id, amount: Number(amount) || 0, ledger: 'internal_driver' }
    });
    return ref;
  },

  async deletePayment(paymentId) {
    const ref = doc(db, COLLECTION_NAME, paymentId);
    let before = null;
    try {
      const snap = await getDoc(ref);
      if (snap.exists()) before = { id: snap.id, ...snap.data() };
    } catch { /* best effort */ }
    const result = await deleteDoc(ref);
    auditService.log({
      module: AUDIT_MODULES.PAYMENT,
      action: AUDIT_ACTIONS.PAYMENT_DELETED,
      recordId: paymentId,
      recordLabel: `Driver payment ${before?.amount ?? '?'} → ${before?.driverId ?? '?'}`,
      before,
      after: null,
      tags: [AUDIT_TAGS.ALL, AUDIT_TAGS.FINANCIAL, AUDIT_TAGS.DRIVER_CHANGES, AUDIT_TAGS.DELETIONS],
      companyId: before?.companyId,
      meta: { driverId: before?.driverId, paymentNumber: paymentId, amount: before?.amount, ledger: 'internal_driver' }
    });
    return result;
  }
};
